import { MeetingInformationSlider} from "./MeetingInformationSlider";

export default MeetingInformationSlider;
